// 완료자 필터에 노출할 그룹 (삭제 여부와 무관하게 그룹으로만 구분)
export const COMPLETER_GROUP_TITLES = ['수학콘텐츠', '시중교재스크랩', '퇴사자', '스크랩이미지제작', '내신기출스크랩', '창작인턴'];
